import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Locations = lazy(() => import("@/pages/Locations"));

export const Route = createFileRoute("/_public/locations")({
  head: () => pageHead({ path: "/locations", title: "Locations | Amorette Launch Markets & Waitlists", description: "See every market where Amorette curated social dining is launching. Join a market waitlist to be notified first." }),
  component: Locations,
});
